import { render, staticRenderFns } from "./NewsLetter.vue?vue&type=template&id=4c85bc14&scoped=true"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"
import style0 from "./NewsLetter.vue?vue&type=style&index=0&id=4c85bc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85bc14",
  null
  
)

export default component.exports